import React from "react";
import SimpleReactFooter from "simple-react-footer";
import Socialtab from "./Socialtab";

function Footer(){

  const title = "Contents";
  
  const link  = <p>In this portfolio, you can be able to review all my education details, career experience details, all the recent projects that I have worked with and every detail about my technical skills. For more informations, please do not hesitate to write emails to : <a className="email" href="mailto:vembarasugn@gmail.com"> vembarasugn@gmail.com</a></p>;

  const description = <>{link}</>

  const columns = [
    {
        title: "Resources",
        resources: [
            {   
                name: "About",
                link: "/About"
            },
            {   
                name: "Projects",
                link: "/Projects"
            }
        ]
    },
    {
        title: "Legal",
        resources: [
            {   
                name: "Privacy",
                link: "/"
            },
            {
                name: "Terms",
                link: "/"
            }
        ]
    },
    {
        title: "Visit",
        resources: [
            {   
                name: "Locations",
                link: "https://goo.gl/maps/XZQCukTRYweLNPkv7"
            },
            {
                name: "showmore",
                link: "/"
            }
        ]
    }
 ]  
                
 return (
 <section>
     <SimpleReactFooter 
     title={title}
     description={description} 
     columns={columns}
     copyright="2025"
     iconColor="black"
     backgroundColor="#222831"
     fontColor="#F2F2F2"
     copyrightColor="#F2F2F2"   
    />
    <Socialtab/> 
 </section>
)} 
 
export default Footer;
                
                        







